import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'showColumns',
    standalone: false
})
export class ShowColumnsPipe implements PipeTransform {
    transform(columns: any[], displayed: string[]): any[] {
        let newColumns: any[] = [];
        if (!displayed) {
            return columns;
        }
        displayed.forEach((d) => newColumns.push(columns.find((c) => c.header === d)));
        return newColumns;
    }
}
